import type {
  StaticNavigationNavigationItemDtoLinkType,
  StaticApplicationsFooterBffNavigationDto,
  StaticApplicationsFooterBffNavigationItemDto,
} from '@ori/static-api-client-react';

export const extractChildrenWithNavigationType = (
  linkType: StaticNavigationNavigationItemDtoLinkType,
  data?: StaticApplicationsFooterBffNavigationDto | StaticApplicationsFooterBffNavigationItemDto,
) => data?.children.find((x) => x.linkType === linkType);
